import { render, staticRenderFns } from "./CreateUPForm.vue?vue&type=template&id=69df410c"
import script from "./CreateUPForm.vue?vue&type=script&lang=js"
export * from "./CreateUPForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports